import { Boxes, ShoppingCart, Warehouse, Landmark } from "lucide-react";

export const services = [
  {
    slug: "logistics-solutions",
    title: "Logistics Solutions",
    icon: Boxes,
    image:"./img/logistics-solution.webp",
    summary: "End-to-end freight planning and route management for businesses of every size.",
    body:
      "Our logistics solutions cover everything from route planning to multi-modal transport coordination, giving you a single point of contact for cargo moving across the country.",
  },
  {
    slug: "ecommerce-logistics",
    title: "E-Commerce Logistics",
    icon: ShoppingCart,
    image:"./img/ecommerce-logistics.webp",
    summary: "Pick, pack, and last-mile delivery built for high-volume online sellers.",
    body:
      "We plug directly into your storefront workflow — carton labelling, marketplace-ready packaging, and reliable last-mile delivery so every order reaches the customer on time.",
  },
  {
    slug: "warehousing-solutions",
    title: "Warehousing Solutions",
    icon: Warehouse,
    image:"./img/warehouse.webp",
    summary: "Secure, scalable storage with real-time inventory visibility.",
    body:
      "Our warehousing network gives you flexible short and long-term storage, inventory tracking, and cross-docking so stock keeps moving instead of sitting idle.",
  },
  {
    slug: "government-project-deliveries",
    title: "Government Project Deliveries",
    icon: Landmark,
    image:"./img/project-delivery.webp",
    summary: "Compliant, on-schedule delivery for public sector and infrastructure projects.",
    body:
      "We handle the documentation, compliance, and scheduling demands of government and infrastructure projects, delivering critical materials on time, every time.",
  },
];
